import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProjectType } from '../../../../interfaces/Projects/Catalogs/projectTypes';
import GenericPromises from '../../../../api/GenericPromises';
import { Menuitem } from '../../../../interfaces/Security/menu';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';
import { usePermissions } from '../../../../hooks/usePermissions';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { ButtonStyled } from '../../../../theme/buttons';
import { Button } from '@mui/material';
import { UpdateProjectTypes } from './update';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';

export const ViewProjectTypes = () => {

    const [t] = useTranslation("global");
    const location = useLocation();
    const navigate = useNavigate();
    const [projectTypeLocal, setProjectTypeLocal] = useState<ProjectType>();
    const [openDialog, setOpenDialog] = useState(false);
    const [dataloaded, setDataLoaded] = useState(false);
    const { GenericGetResource, GenericDeleteResource } = GenericPromises();
    const [resourceScreen, setResourceScreen] = useState<Menuitem>();
    const { showSnackBar, SnackbarComponent } = useSnackBar();

    const { GetResourceByUrl } = usePermissions();

    const onDelete = () => {
        GenericDeleteResource(`/projecttypes/${projectTypeLocal?.project_type_id}`)
            .then(() => {
                setOpenDialog(false);
                navigate("/projecttypes", { state: { method: "delete" }, replace: true });
            })
            .catch((error) => {
                showSnackBar(error.message, "error");
                setOpenDialog(false);
            })
    }

    useEffect(() => {
        if (location.state === null) return navigate("/projecttypes", { state: {}, replace: true });
        GenericGetResource(`/projecttypes/${location.state.row.project_type_id}`)
            .then(
                (response) => {
                    setProjectTypeLocal(response.data);

                    GetResourceByUrl(`/projecttypes`)
                        .then((response1) => {
                            setResourceScreen((prev) => response1);
                            setDataLoaded(true);
                        })
                        .catch((error) => {
                            showSnackBar(error.message, "error");
                        });
                }
            ).catch((error) => {
                showSnackBar(error.message, "error");
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {!dataloaded && <Spinner />}
            {dataloaded &&
                <>
                    <Header
                        title={t("projecttypes.title-view")}
                        child={
                            <div className='d-flex flex-row-reverse m-1'>
                                {resourceScreen?.delete === true &&
                                    <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                                }
                                <Button variant="outlined" onClick={() => { navigate("/projecttypes", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
                            </div>
                        }
                    />
                    {resourceScreen?.read &&
                        <>
                            <div>
                                <UpdateProjectTypes projectTypePayload={projectTypeLocal} isEdit={resourceScreen?.update} />
                            </div>
                        </>
                    }
                </>
            }
            <GenericDialog
                title={t("generic.dialog.delete")}
                content={t("projecttypes.dialog.delete")}
                open={openDialog}
                setOpen={setOpenDialog}
                onAcept={onDelete}
            />
            <SnackbarComponent />
        </>
    )
}
